import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const translations = {
    it: {
        nav: {
            home: "Home",
            experiences: "Esperienze",
            transfers: "Transfer",
            destinations: "Destinazioni",
            tailor: "Su Misura",
            contacts: "Contatti",
            itineraries: "Itinerari",
            createItinerary: "Itinerari su misura",
            stays: "Alloggi",
            about: "Chi siamo",
            favorites: "I tuoi preferiti",
            favoritesEmpty: "Nessuna esperienza salvata: tocca il cuore sulle schede.",
            account: "Area cliente",
            bookNow: "Richiedi itinerario",
            admin: "Area Gestionale",
            statusPage: "Stato richiesta",
        },
        itinerariesPage: {
            title: "Itinerari e viaggi proposti",
            sub: "Le esperienze e i viaggi d'autore curati da TOURVOYAGERS: consulta le proposte, scopri i dettagli e prenota. Per un viaggio disegnato su di te, apri il configuratore.",
            customTitle: "Crea il tuo itinerario su misura",
            customSub: "Destinazioni, date, esperienze, alloggi e preventivo: il configuratore completo",
            empty: "Nessun itinerario disponibile al momento.",
        },
        concierge: {
            fab: "Concierge AI",
            pageTitle: "Il tuo Concierge di viaggio AI",
            pageSub: "Raccontami il viaggio che sogni: ti farò qualche domanda e comporrò una proposta su misura con i servizi reali Tourvoyagers.",
            greeting: "Ciao! Sono il tuo Concierge di viaggio. Dimmi cosa vorresti vivere in Italia e ti aiuterò a creare un itinerario su misura.",
            placeholder: "Scrivi qui i tuoi desideri di viaggio…",
            send: "Invia", thinking: "Il Concierge sta scrivendo…", reset: "Nuova conversazione",
            chips: ["7 giorni tra Roma e Costiera Amalfitana", "Weekend romantico a Roma", "Roma, Firenze e Venezia in 10 giorni"],
            proposalTitle: "La tua proposta di viaggio", stopsTitle: "Le tappe", nights: "notti",
            servicesTitle: "Servizi della proposta", priceQuote: "da preventivare",
            warningsTitle: "Note del Concierge",
            participants: "Partecipanti", pace: "Ritmo", budget: "Budget indicativo",
            mapTitle: "Il percorso",
            requestCta: "Richiedi questa proposta",
            disclaimer: "Proposta non vincolante: prezzi e disponibilità vengono verificati dal team prima di qualsiasi conferma.",
            editHint: "Vuoi modificare qualcosa? Scrivilo in chat, ad esempio «un giorno in più a Firenze» o «aggiungi un'esperienza gastronomica».",
            formTitle: "Quasi fatto",
            formSub: "Lascia i tuoi contatti: il team verifica disponibilità e prezzi e ti invia il preventivo.",
            cfName: "Nome e cognome", cfEmail: "Email", cfPhone: "Telefono",
            cfPrivacy: "Ho letto e accetto l'informativa privacy",
            cfSend: "Invia la richiesta", cfSending: "Invio in corso…",
            successTitle: "Proposta inviata al team",
            successMsg: "La tua proposta è in attesa di conferma: ti contatteremo con il preventivo verificato.",
            codeLabel: "Codice richiesta",
            error: "Il Concierge non è disponibile in questo momento. Riprova tra poco.",
            langNote: "La lingua del sito è la lingua della conversazione: puoi cambiarla quando vuoi senza perdere nulla.",
            listening: "Sto ascoltando… tocca per fermare",
            transcribing: "Trascrivo la tua voce…",
            micDenied: "Microfono non disponibile: controlla i permessi del browser.",
            voiceOn: "Disattiva la lettura vocale",
            voiceOff: "Attiva la lettura vocale delle risposte",
            journeyTitle: "Il tuo viaggio personalizzato",
            editItinerary: "Modifica itinerario", doneEdit: "Fine modifiche",
            addDestination: "Aggiungi destinazione", chooseCity: "Scegli una destinazione…",
            removeStop: "Rimuovi tappa", askAi: "Chiedi all'AI", viewMap: "Vista sulla mappa", hideMap: "Nascondi mappa",
            day: "Giorno",
            programDefault: "Il programma dettagliato della giornata viene definito con il nostro team in fase di preventivo.",
            linkedServices: "Servizi collegati a questa tappa",
            tabStays: "Alloggi", tabExperiences: "Esperienze", tabTransfers: "Transfer", tabRestaurants: "Ristoranti", tabActivities: "Attività",
            selectedForYou: "Selezionato per te", addedByYou: "Aggiunto da te",
            seeDetails: "Vedi dettagli", seeAll: "Vedi tutti", seeLess: "Mostra meno",
            replace: "Sostituisci", remove: "Rimuovi", close: "Chiudi", backToTrip: "Torna al viaggio",
            emptyServices: "Le tue selezioni appariranno qui quando avremo personalizzato il viaggio insieme.",
            emptyItinerary: "Raccontami il viaggio che sogni: qui comparirà il tuo itinerario personalizzato, con tappe, mappa e servizi reali.",
            restaurantsNote: "La selezione dei ristoranti è in fase di integrazione con il catalogo: per correttezza non mostriamo locali non verificati. Chiedi al Concierge di includere i ristoranti nella richiesta e il team li proporrà nel preventivo.",
            askRestaurants: "Chiedi al Concierge i ristoranti",
            restaurantsMsg: "Vorrei includere nel viaggio dei ristoranti selezionati: quali mi consigliate per le mie tappe?",
            swapTitle: "Scegli un'alternativa dal catalogo reale", swapSearch: "Cerca per nome o località…",
            swapEmpty: "Nessuna alternativa trovata nel catalogo.", swapSelect: "Scegli", swapLoading: "Carico il catalogo…",
            summaryTitle: "Riepilogo viaggio", duration: "Durata", days: "giorni",
            destinations: "Destinazioni", travelers: "Viaggiatori",
            sumStays: "Alloggi selezionati", sumExperiences: "Esperienze incluse", sumTransfers: "Transfer inclusi",
            sumActivities: "Attività ed escursioni", sumRestaurants: "Ristoranti",
            totalLabel: "Totale indicativo", totalKnownNote: "solo servizi con prezzo noto · non vincolante",
            totalUnknown: "Prezzo nel preventivo",
            quoteCta: "Richiedi preventivo personalizzato",
            recapTitle: "Il tuo viaggio in sintesi",
            toastAdded: "Aggiunto al tuo viaggio", toastRemoved: "Rimosso dal viaggio", toastReplaced: "Servizio sostituito",
            toastStopAdded: "Tappa aggiunta", toastStopRemoved: "Tappa rimossa",
            quickActions: ["Crea un itinerario", "Trova alloggi", "Esperienze ed escursioni", "Transfer privati", "Ristoranti selezionati"],
            quickMsgs: ["Vorrei creare un itinerario su misura in Italia", "Cerco un alloggio di lusso per il mio viaggio", "Vorrei esperienze ed escursioni autentiche", "Ho bisogno di un transfer privato", "Vorrei consigli su ristoranti selezionati per il mio viaggio"],
            askAiStop: "Vorrei modificare la tappa a {city}.",
            sidebarQuote: "«Il lusso non è solo destinazione, ma il modo in cui vivi il viaggio.»",
            myTrips: "I tuoi viaggi", restaurants: "Ristoranti",
            cuisineLabel: "Cucina", priceRange: "Fascia di prezzo", priceSourceGoogle: "fonte Google",
            tableNote: "La prenotazione del tavolo è una richiesta al team: nessun tavolo è confermato automaticamente.",
            restEmpty: "I ristoranti che sceglieremo insieme appariranno qui: chiedi al Concierge i migliori per le tue tappe.",
        },
        statusPage: {
            title: "Stato della tua richiesta",
            sub: "Inserisci il codice ricevuto alla prenotazione e l'email utilizzata.",
            codeLabel: "Codice prenotazione",
            codePlaceholder: "es. TO-2026-0007",
            emailLabel: "Email utilizzata",
            check: "Verifica stato",
            checking: "Verifica in corso…",
            notFound: "Nessuna richiesta trovata con questi dati. Controlla codice ed email.",
            registered: "Richiesta registrata nel gestionale Tourvoyagers.",
            liveNote: "Stato aggiornato in tempo reale dal gestionale.",
            lastKnownNote: "Ultimo stato noto: in attesa di conferma. La conferma arriva via email appena l'operatore la registra.",
            packageLabel: "Servizio",
            dateLabel: "Data e ora",
        },
        hero: {
            overline: "YOUR JOURNEY, YOUR STORY",
            titleA: "Discover Italy",
            titleB: "beyond the ordinary.",
            subtitle: "Esperienze autentiche, itinerari su misura, transfer e alloggi per un viaggio indimenticabile.",
            perks: ["Esperienze selezionate", "Servizio personalizzato", "Assistenza 24/7"],
            ctaExperiences: "Esplora le Esperienze",
            ctaTransfers: "Prenota un Transfer",
            ctaAI: "Crea il tuo viaggio con il Concierge AI",
            ctaExplore: "Esplora e prenota autonomamente",
            scroll: "Scorri per esplorare",
        },
        search: {
            tabItinerary: "Crea il tuo itinerario",
            tabTransfer: "Transfer aeroportuali",
            tabStays: "Alloggi",
            tabExperiences: "Esperienze",
            where: "Dove vuoi andare?", wherePh: "Roma, Toscana, Costiera…",
            dates: "Date del viaggio", dateFrom: "Dal", dateTo: "Al",
            people: "Persone", tripType: "Tipo di viaggio", tripTypePh: "Cultura, Relax, Enogastronomia…",
            from: "Partenza", fromPh: "Aeroporto / Hotel / Indirizzo",
            to: "Destinazione", toPh: "Destinazione",
            date: "Data", time: "Ora", pax: "Passeggeri", bags: "Bagagli",
            hub: "Aeroporto o porto", hubFco: "Aeroporto di Fiumicino (FCO)", hubCia: "Aeroporto di Ciampino (CIA)", hubCiv: "Porto di Civitavecchia", hubOther: "Altro indirizzo",
            vehicle: "Veicolo",
            destination: "Destinazione", checkin: "Check-in", checkout: "Check-out", guests: "Ospiti", rooms: "Camere", stayType: "Tipologia",
            stayTypes: { any: "Qualsiasi", hotel: "Hotel", boutique: "Boutique Hotel", resort: "Resort", bb: "B&B", villa: "Villa", apartment: "Appartamento" },
            category: "Categoria", anyCategory: "Tutte le categorie",
            ctaItinerary: "Crea itinerario", ctaTransfer: "Richiedi transfer", ctaStays: "Cerca alloggi", ctaExperiences: "Scopri le esperienze",
            mini: ["Itinerario personalizzato", "Preventivo gratuito", "Nessun impegno", "Consulenza di esperti"],
            required: "Compila i campi evidenziati per continuare.",
            expPh: "Cerca un'esperienza o una città…",
        },
        trust: ["Autisti professionisti", "Veicoli di alta gamma", "Assistenza 24/7", "Prenotazione sicura"],
        builder: {
            heroTitleA: "Italy.", heroTitleB: "Your Way.",
            heroSub: "Crea il tuo viaggio italiano: dai momenti indimenticabili a Roma alle esperienze straordinarie in tutta Italia.",
            ctaCreate: "Crea il tuo viaggio", ctaTours: "Esplora i Signature Tours",
            steps: [
                { t: "Pianifica il viaggio", d: "Destinazioni, date e stile" },
                { t: "Aggiungi luoghi ed esperienze", d: "Scegli dalla nostra selezione" },
                { t: "Vedi il tuo itinerario", d: "Mappa, timeline e anteprima visuale" },
                { t: "Prenota o richiedi", d: "Prenotazione immediata o preventivo su misura" },
            ],
            chooseTitle: "Dove vuoi andare?",
            chooseSub: "Un tour privato nella sola Roma, oppure un viaggio attraverso l'Italia: scegli la modalità.",
            romeCard: "Explore Rome",
            romeSub: "Crea il tuo tour privato perfetto tra monumenti iconici, strade storiche e angoli nascosti di Roma.",
            italyCard: "Discover Italy",
            italySub: "Progetta un viaggio su misura attraverso l'Italia, combinando città, paesaggi, cultura ed esperienze indimenticabili.",
            examples: ["Roma → Firenze → Venezia", "Roma → Napoli → Costiera Amalfitana", "Milano → Lago di Como → Verona → Venezia"],
            examplesNote: "Esempi di itinerari: le destinazioni prenotabili provengono dal catalogo reale.",
            start: "Inizia", changeMode: "Cambia modalità",
            signatureTitle: "Signature Tours",
            signatureSub: "I tour del catalogo ufficiale Tourvoyagers: prenotabili così come sono o personalizzabili su misura.",
            explore: "Explore Tour", customize: "Personalizza questo tour",
            prefDate: "Data desiderata", prefPax: "Partecipanti", prefTime: "Tempo disponibile", prefInterests: "Interessi", prefPace: "Ritmo preferito",
            paces: { relaxed: "Rilassato", balanced: "Equilibrato", intense: "Intenso" },
            times: { "2h": "Fino a 2 ore", "4h": "Mezza giornata (4h)", "8h": "Giornata intera (8h)", multi: "Più giornate" },
            interests: { history: "Storia e Cultura", art: "Arte e Architettura", food: "Enogastronomia", hidden: "Angoli nascosti", views: "Viste panoramiche", shopping: "Shopping", religious: "Patrimonio religioso", family: "Esperienze in famiglia", nature: "Natura e parchi", sea: "Mare e borghi costieri", craft: "Artigianato e tradizioni", exclusive: "Esperienze esclusive", wellness: "Benessere e terme", archeology: "Archeologia e siti storici" },
            catalogTitle: "Catalogo dei luoghi", destCatalogTitle: "Destinazioni italiane",
            searchPh: "Cerca luoghi, monumenti, quartieri…", destSearchPh: "Cerca destinazioni, città, regioni…",
            add: "Aggiungi", added: "Aggiunto", remove: "Rimuovi",
            yourTour: "Il tuo tour di Roma", yourJourney: "Il tuo viaggio in Italia",
            stopsEmpty: "Nessuna tappa ancora: aggiungi luoghi dal catalogo.",
            destEmpty: "Nessuna destinazione ancora: aggiungila dal catalogo.",
            nights: "notti", night: "notte", addDest: "Aggiungi un'altra destinazione",
            startDate: "Data di partenza", transport: "Trasporto preferito",
            transports: { car: "Vettura", minivan: "Minivan", sprinter: "Mercedes-Benz Sprinter" },
            transportCap: "fino a {n} persone",
            capWarn: "Il gruppo di {pax} persone supera la capienza di {name} (max {cap} persone).",
            capWarnHint: "Scegli un mezzo più capiente oppure richiedi una soluzione personalizzata: la concorderemo con te.",
            capCustomBtn: "Richiedi soluzione personalizzata",
            capCustomSet: "Soluzione personalizzata richiesta: la concorderemo con te",
            budget: "Budget indicativo (facoltativo)", budgetPh: "es. 4.000",
            budgetHint: "Per l'intero viaggio · non vincolante",
            wizard: {
                steps: [
                    { t: "Destinazioni", d: "Città, date e tappe" },
                    { t: "Alloggi", d: "Dove dormirai" },
                    { t: "Trasporti", d: "Mezzo e passeggeri" },
                    { t: "Esperienze", d: "Cosa vivrai" },
                    { t: "Riepilogo", d: "Budget e preventivo" },
                ],
                back: "Indietro", next: "Continua",
                staysTitle: "I tuoi alloggi", staysSub: "Scegli dove dormire in ogni tappa: disponibilità e prezzo vengono verificati nel preventivo.",
                staysEmpty: "Aggiungi prima almeno una destinazione al tuo viaggio.", staysGo: "Vai alle destinazioni",
                stayPick: "Scegli alloggio", stayChange: "Cambia",
                transportTitle: "Il tuo trasporto", transportSub: "Indica partecipanti e mezzo preferito: la disponibilità viene verificata col preventivo.",
                fleetTitle: "La flotta a tua disposizione",
                expStepTitle: "Le tue esperienze", expStepSub: "Scegli una categoria e aggiungi esperienze reali al tuo itinerario.",
                expAddedTitle: "Esperienze nel tuo itinerario",
                summaryTitle: "Ultimo passo", summarySub: "Indica un budget indicativo (facoltativo), guarda l'anteprima del viaggio e richiedi il preventivo.",
                quoteCta: "Richiedi il preventivo",
            },
            catSub: {
                history: "Monumenti, musei, città storiche e tesori del passato.",
                art: "Musei, palazzi, ville storiche e capolavori dell'arte italiana.",
                food: "Cantine, degustazioni, frantoi, prodotti DOP e cucina regionale.",
                hidden: "Borghi, quartieri caratteristici e luoghi fuori dai percorsi noti.",
                views: "Terrazze, belvedere e strade panoramiche tra città, colline e coste.",
                shopping: "Boutique, outlet, botteghe artigiane e mercati storici.",
                religious: "Basiliche, santuari, abbazie e itinerari spirituali.",
                family: "Parchi, musei e attività pensate per viaggiare con i bambini.",
                nature: "Parchi nazionali, giardini storici e riserve naturali.",
                sea: "Borghi sul mare, spiagge ed escursioni in barca.",
                craft: "Ceramiche, vetro, pelletteria e antichi mestieri italiani.",
                exclusive: "Visite private ed esperienze riservate, su misura.",
                wellness: "Terme, sorgenti naturali ed esperienze di benessere.",
                archeology: "Scavi, templi e siti archeologici unici al mondo.",
            },
            expFilters: "Filtri", expRegion: "Regione", expAllRegions: "Tutte le regioni",
            expDur: "Durata", expDurAll: "Qualsiasi durata", expDurShort: "Fino a 3 ore", expDurHalf: "Mezza giornata", expDurFull: "Giornata intera",
            expAdd: "Aggiungi all'itinerario", expAdded: "Nell'itinerario", expRemove: "Rimuovi",
            expDurIndicative: "durata indicativa",
            expPriceNote: "Prezzo e disponibilità verranno verificati e comunicati nel preventivo finale.",
            expEmpty: "Nessuna esperienza disponibile con questi filtri.",
            expRomeNote: "Modalità Scopri Roma: esperienze di Roma e dintorni.",
            expBadge: "Esperienza", expClose: "Chiudi il catalogo", expLoading: "Carichiamo le esperienze…",
            sumExperiences: "Esperienze selezionate", sumBudget: "Budget indicativo",
            days: "Giorni", sumStops: "Tappe", sumDuration: "Durata stimata", sumCities: "Destinazioni", sumNights: "Notti", sumExp: "Esperienze",
            sumDistance: "Distanza totale", sumDrive: "Tempo di guida", customPlace: "da Google Maps",
            estTitle: "Stima indicativa", estNote: "Fascia non vincolante basata su tappe, chilometri reali e partecipanti: il preventivo personale arriva dopo la richiesta.",
            modeRome: "Scopri Roma", modeRomeSub: "Un'esperienza dedicata alla Città Eterna",
            modeItaly: "Tour dell'Italia", modeItalySub: "Più destinazioni, esperienze e alloggi",
            heroLabel: "IL TUO VIAGGIO", heroItalyTitle: "Scopri l'Italia", heroRomeTitle: "Scopri Roma",
            heroItalySub: "Disegna un viaggio su misura attraverso l'Italia, tra città, paesaggi, cultura ed esperienze indimenticabili.",
            heroRomeSub: "Disegna la tua esperienza nella Città Eterna: monumenti, quartieri, arte e momenti indimenticabili.",
            addDestination: "Aggiungi destinazione", addPlace: "Aggiungi luogo", exploreMore: "Esplora altre destinazioni",
            continueSummary: "Continua al riepilogo", yourJourneyTitle: "Il tuo viaggio", yourJourneySub: "Le tue destinazioni e tappe selezionate",
            yourRomeTitle: "Il tuo soggiorno romano", yourRomeSub: "Le tue visite organizzate giorno per giorno",
            accommodationBtn: "Alloggio", attractionsBtn: "Attrazioni", nightsShort: "Notti",
            featExplore: "Esplora le città", featExploreSub: "Monumenti, storia e cultura",
            featStays: "Scegli gli alloggi", featStaysSub: "Hotel, boutique e appartamenti",
            featTailor: "Itinerario su misura", featTailorSub: "Tutto in un unico viaggio",
            featExclusive: "Esperienze esclusive", featExclusiveSub: "Vivi l'Italia con noi",
            addDestinations: "Aggiungi destinazioni", searchCityPh: "Cerca una città…", popularDest: "Destinazioni popolari",
            exploreCity: "Esplora la città", findStay: "Trova il tuo alloggio",
            attractionsSelected: "{n} attrazioni selezionate", noAttractions: "Nessuna attrazione ancora",
            staySelected: "Alloggio selezionato", stayMissing: "Alloggio non ancora selezionato", stayReconfirm: "Da riconfermare: le date sono cambiate",
            staySetDates: "Imposta la data di partenza per calcolare le date della tappa",
            sumStays: "Alloggi selezionati", sumStayCost: "Costo alloggi (indicato da te)", sumTotal: "Totale indicativo",
            sumTitle: "Riepilogo del viaggio", sumAttractions: "Attrazioni selezionate",
            requestQuote: "Richiedi preventivo", programTitle: "Programma delle visite",
            dayAssign: "Giorno", dayUnassigned: "Da pianificare", dayN: "Giorno {n}",
            romeStayDays: "Giorni a Roma", arrival: "Arrivo", departure: "Partenza",
            xp: {
                back: "Torna al viaggio", story: "Storia e origini", periods: "I grandi periodi",
                heritage: "Patrimonio artistico e culturale", distinctive: "Cosa la rende unica",
                tips: "Consigli per organizzare la visita", gallery: "Le attrazioni",
                mustSee: "Da non perdere", allCats: "Tutte", searchPh: "Cerca un luogo, un monumento…",
                discoverStory: "Scopri la storia", add: "Aggiungi al mio itinerario", added: "Nel tuo itinerario",
                curiosity: "Curiosità", practical: "Consigli pratici", duration: "Visita consigliata",
                needCity: "Aggiungi prima {city} al tuo viaggio per selezionare le attrazioni",
                loading: "Prepariamo la guida di {city}…", loadingSub: "Testi, fotografie e posizioni reali in arrivo",
                noResults: "Nessuna attrazione corrisponde alla ricerca.",
                retry: "Riprova", errorMsg: "La guida non si è caricata completamente. Controlla la connessione e riprova: i contenuti sono pronti ad arrivare.",
            },
            stay: {
                title: "Il tuo alloggio a {city}", dates: "Check-in → Check-out", guests: "Ospiti", rooms: "Camere",
                type: "Tipologia preferita", anyType: "Qualsiasi",
                types: { luxury: "Hotel di lusso", boutique: "Hotel boutique", mid: "Fascia media", bb: "Bed & Breakfast", apartment: "Appartamento", residence: "Residence" },
                searchPartner: "Cerca su Booking.com con queste date",
                partnerNote: "Prezzi, foto e disponibilità reali sono sul sito del partner: la prenotazione si completa lì, poi registra qui la tua scelta per includerla nel preventivo.",
                register: "Registra la struttura scelta", namePh: "Nome struttura (es. Hotel Artemide)",
                pricePh: "Prezzo totale soggiorno € (facoltativo)", linkPh: "Link della struttura (facoltativo)",
                save: "Salva alloggio", replace: "Sostituisci", remove: "Rimuovi",
                statusSelected: "Selezionato — prenotazione da completare sul partner",
                listSub: "Seleziona l'alloggio per questa tappa: proposte verificate oppure una soluzione personalizzata.",
                editDates: "Modifica date e ospiti", catLabel: "Categoria", catAll: "Tutte le categorie",
                catLuxury: "Lusso", catMid: "Fascia media", catValue: "Essenziale", searchNamePh: "Cerca una struttura…",
                viewMap: "Vedi sulla mappa", select: "Seleziona questo alloggio", selected: "Selezionato", removeSel: "Rimuovi selezione",
                priceNote: "Il prezzo dell'alloggio verrà comunicato nel preventivo finale, previa verifica della disponibilità.",
                priceSummary: "Prezzo da definire nel preventivo finale",
                ratingSuffix: "su Google · {n} recensioni",
                noFit: "Non trovi la soluzione adatta?", customCta: "Richiedi proposta personalizzata",
                customPh: "Descrivi le tue esigenze: stile, zona, servizi desiderati…",
                customName: "Proposta personalizzata", skip: "Salta e continua",
                emptyCatalog: "Il catalogo verificato per questa destinazione è in preparazione: nel frattempo puoi richiedere una proposta personalizzata.",
                partnerFallback: "Cerca comunque sul partner",
                viewPhotos: "Sfoglia la galleria", backToResults: "Torna ai risultati", photoCount: "{n} foto",
                photosCredit: "Fotografie reali della struttura · Fonte: Google Maps",
                noMorePhotos: "Non sono disponibili altre immagini verificate per questa struttura.",
                roomsTitle: "Tipologie di camera",
                roomsNote: "Fotografie e dettagli specifici delle camere (letti, superficie, servizi inclusi, colazione e cancellazione) non sono disponibili dalla fonte verificata: ti verranno proposti nel preventivo finale, previa verifica della disponibilità.",
            },
            partialNote: "Stima parziale: durate indicative delle visite più tempi di guida reali calcolati con Google Maps; servizi extra esclusi.",
            day: "Giorno", daysRange: "Giorni",
            suggNearby: "Potresti aggiungere anche {name}.",
            suggRelaxed: "Con ritmo rilassato, {n} tappe potrebbero essere troppe per il tempo disponibile.",
            suggDest: "{name} si abbinerebbe bene al tuo viaggio.",
            mapIndicative: "Mappa, posizioni e connessioni stradali reali calcolate con Google Maps.",
            mapLegendStops: "Tappe", mapLegendAttractions: "Attrazioni", mapLegendStays: "Alloggi",
            placesPh: "Cerca qualsiasi luogo o città con Google…",
            mapFallbackTitle: "Mappa interattiva",
            mapFallbackText: "La mappa Google Maps si attiva non appena viene configurata la chiave API. Intanto gestisci l'ordine delle tappe dalla lista: posizioni e coordinate sono già quelle reali.",
            preview: "Anteprima del viaggio",
            pvVisual: "Viaggio visuale", pvMap: "Mappa interattiva", pvDays: "Itinerario giorno per giorno", pvDetails: "Dettagli",
            request: "Richiedi il mio viaggio su misura",
            bkTitle: "Richiedi il tuo viaggio su misura",
            bkSub: "L'intera struttura del tuo itinerario viene inviata al gestionale Tourvoyagers.",
            bkSubmit: "Invia la richiesta",
            bkSuccessTitle: "Richiesta ricevuta",
            bkSuccessMsg: "Il tuo itinerario è stato registrato nel gestionale Tourvoyagers con la struttura completa del viaggio. Non è una prenotazione confermata: ti contatteremo con una proposta.",
        },
        marquee: ["ROME", "PRIVATE TRANSFERS", "TAILOR-MADE JOURNEYS", "EXCLUSIVE EXPERIENCES", "CIVITAVECCHIA CRUISE TRANSFERS", "TRAVEL DIFFERENTLY"],
        home: {
            featuredOverline: "Le nostre collezioni",
            featuredTitle: "Esplora le esperienze",
            featuredSub: "Ogni itinerario è pensato per farti vivere Roma e i suoi dintorni in modo autentico e indimenticabile.",
            viewAll: "Vedi tutte le esperienze",
            dest2: {
                title: "Destinazioni in evidenza",
                cards: [
                    { key: "roma", name: "Roma" },
                    { key: "costiera", name: "Costiera Amalfitana" },
                    { key: "toscana", name: "Toscana" },
                    { key: "food", name: "Esperienze Enogastronomiche" },
                    { key: "arte", name: "Arte e Cultura" },
                    { key: "tour", name: "Tour Privati" },
                ],
            },
            featExp: {
                title: "Esperienze in evidenza", viewAll: "Vedi tutte le esperienze",
                quoteTag: "Prezzo nel preventivo", perPersonNote: "Disponibilità e prezzo verificati nel preventivo",
            },
            transferBanner: {
                label: "TRANSFER AEROPORTUALI", title: "Arriva in Italia senza pensieri",
                sub: "Transfer privati da e per Fiumicino, Ciampino e tutti gli altri aeroporti italiani.",
                cta: "Prenota il tuo transfer",
                meetGreet: "Meet & Greet in aeroporto",
                freeWait: "Attesa gratuita fino a {n} minuti",
                flightTrack: "Monitoraggio del volo",
                luggage: "Assistenza bagagli",
                proDrivers: "Autisti professionisti e multilingue",
            },
            hubsOverline: "ARRIVI & PARTENZE",
            hubsTitle: "Da qualunque hub arrivi, ti accogliamo noi",
            hubCta: "Richiedi transfer",
            hubs: [
                { slug: "transfer-fco", name: "Aeroporto di Fiumicino", sub: "FCO · Leonardo da Vinci, terminal arrivi" },
                { slug: "transfer-cia", name: "Aeroporto di Ciampino", sub: "CIA · G. B. Pastine" },
                { slug: "transfer-civitavecchia", name: "Porto di Civitavecchia", sub: "Terminal crociere" },
            ],
            staysBanner: {
                label: "ALLOGGI SELEZIONATI", title: "Soggiorna in luoghi unici",
                sub: "Hotel, Boutique Hotel, Ville e Appartamenti dei nostri partner selezionati.",
                cta: "Scopri gli alloggi",
                chips: ["Strutture verificate", "Assistenza dedicata", "Prezzo nel preventivo finale"],
            },
            cities: {
                title: "Le nostre destinazioni", viewAll: "Vedi tutte le destinazioni",
                cards: [
                    { key: "roma", name: "Roma", sub: "Storia eterna" },
                    { key: "costiera", name: "Costiera Amalfitana", sub: "Mare e bellezza" },
                    { key: "toscana", name: "Toscana", sub: "Borghi e natura" },
                    { key: "venezia", name: "Venezia", sub: "Arte e romanticismo" },
                    { key: "firenze", name: "Firenze", sub: "Culla del Rinascimento" },
                    { key: "sicilia", name: "Sicilia", sub: "Tradizioni e sapori" },
                ],
            },
            about: {
                title: "Chi siamo",
                text: "L'Italia non è soltanto una destinazione: è un'emozione da vivere. Accompagniamo i viaggiatori alla scoperta della bellezza senza tempo di Roma e dell'Italia, trasformando ogni soggiorno in un'esperienza costruita intorno ai desideri, agli interessi e allo stile di chi viaggia.",
                cta: "Contattaci",
                readMore: "Scopri chi siamo",
            },
            aboutPage: {
                overline: "Rome & Italy Experiences",
                title: "Chi siamo",
                intro1: "L'Italia non è soltanto una destinazione. È un'emozione da vivere, un patrimonio da scoprire, un'esperienza da ricordare.",
                intro2: "Tourvoyagers nasce per accompagnare i viaggiatori alla scoperta della bellezza senza tempo di Roma e dell'Italia, trasformando ogni soggiorno in un'esperienza speciale, costruita intorno ai desideri, agli interessi e allo stile di chi viaggia.",
                intro3: "Crediamo che il vero lusso non sia soltanto raggiungere una destinazione, ma viverla nel modo giusto: con comfort, cura dei dettagli, libertà di scelta e la possibilità di scoprire luoghi, storie e atmosfere che rendono ogni viaggio unico.",
                s1t: "La nostra idea di viaggio",
                s1a: "Dalle meraviglie senza tempo della Città Eterna ai tesori nascosti delle destinazioni italiane, progettiamo esperienze pensate per chi desidera conoscere il territorio con uno sguardo privilegiato.",
                s1b: "Con Tourvoyagers puoi scoprire esperienze esclusive, itinerari su misura, soggiorni selezionati, transfer privati e soluzioni dedicate a rendere ogni spostamento semplice e confortevole.",
                s1c: "Ogni proposta nasce da un principio fondamentale: il viaggio deve adattarsi a te, non il contrario.",
                s2t: "Esperienze create intorno a te",
                s2a: "Ogni viaggiatore ha una storia, un ritmo e un modo personale di scoprire il mondo. Per questo valorizziamo la personalizzazione, l'attenzione alle esigenze individuali e la cura di ogni dettaglio, dalla pianificazione del viaggio fino agli spostamenti e alle esperienze sul posto.",
                s2b: "Che tu desideri esplorare i monumenti più iconici di Roma, lasciarti sorprendere da itinerari autentici, organizzare un soggiorno speciale o raggiungere la tua destinazione con un transfer privato, il nostro obiettivo è offrirti un percorso semplice, piacevole e all'altezza delle tue aspettative.",
                s3t: "L'eleganza dell'ospitalità italiana",
                s3a: "Ci ispiriamo alla capacità tutta italiana di unire bellezza, cultura, stile e accoglienza. Ogni dettaglio conta: il tempo dedicato alla pianificazione, la qualità delle proposte, la comodità degli spostamenti e la serenità di poter contare su un'organizzazione attenta.",
                s3b: "Vogliamo che tu possa concentrarti sulla parte più bella del viaggio: scoprire, emozionarti e creare ricordi.",
                s4t: "La tua prossima esperienza inizia qui",
                s4a: "Roma è il nostro punto di partenza, l'Italia il nostro orizzonte e il mondo dei viaggi la nostra passione.",
                tagline: "Tourvoyagers. Discover Italy. Experience more.",
                s4b: "Lasciati ispirare, raccontaci cosa immagini e inizia a progettare il tuo prossimo viaggio con noi.",
                ctaContact: "Raccontaci il tuo viaggio",
                ctaConcierge: "Parla con il Concierge AI",
            },
            trustBottom: ["Esperienze autentiche selezionate con cura", "Assistenza 24/7 durante il viaggio", "Preventivo gratuito e senza impegno", "Viaggi su misura per ogni esigenza"],
            discover: "Scopri l'esperienza",
            editorialOverline: "Esperienze private",
            editorialTitle: "Tu scegli la destinazione, noi ci occupiamo del resto.",
            editorialFeatures: ["Itinerari personalizzati", "Guide su richiesta", "Auto di gamma", "Esperienze gastronomiche"],
            editorialCta: "Crea il tuo itinerario",
            airportsOverline: "Arrivi & Partenze",
            airportsTitle: "Transfer Aeroportuali",
            airportsSub: "Accoglienza a Fiumicino e Ciampino con autista dedicato, monitoraggio del volo e attesa inclusa.",
            allTransfers: "Tutti i transfer",
            fcoTitle: "Aeroporto di Fiumicino (FCO)",
            fcoSub: "Il gateway internazionale di Roma, a un passo dal centro.",
            ciaTitle: "Aeroporto di Ciampino (CIA)",
            ciaSub: "Collegamento rapido e riservato verso la città.",
            cruiseOverline: "Crociere",
            cruiseTitle: "Porto di Civitavecchia",
            cruiseSub: "Transfer coordinati con gli orari della tua nave, con possibilità di sosta turistica su richiesta.",
            cruiseCta: "Transfer crocieristici",
            destOverline: "Più di un viaggio",
            destTitle: "Destinazioni ed esperienze su misura",
            destSub: "Dalla Città Eterna alle meraviglie del territorio. Itinerari personalizzati per ogni esigenza.",
            destCta: "Richiedi un itinerario",
            travelTitle: "Travel Differently",
            travelSub: "Più di un trasferimento, un'esperienza di viaggio.",
            travelCta: "Contattaci",
            contactOverline: "Contatti & Assistenza",
            contactTitle: "Hai un'idea di viaggio? Parliamone.",
            contactSub: "Il nostro team è a disposizione per creare con te un'esperienza su misura.",
            contactCta: "Contattaci",
        },
        staysPage: {
            overline: "ALLOGGI SELEZIONATI", title: "Soggiorna in luoghi unici",
            sub: "Hotel, Boutique Hotel, Ville e Appartamenti verificati dei nostri partner, città per città. Il prezzo viene sempre comunicato nel preventivo finale, previa verifica della disponibilità.",
            choose: "Scegli una destinazione per scoprire le strutture selezionate.",
            resultsIn: "strutture selezionate a", reviews: "recensioni", rooms: "Camere",
            cta: "Richiedi con itinerario", empty: "Nessuna struttura disponibile per questa destinazione al momento.",
        },
        destinations: [
            { key: "roma", name: "Roma", sub: "La Città Eterna" },
            { key: "tivoli", name: "Tivoli", sub: "Ville e giardini imperiali" },
            { key: "castelli", name: "Castelli Romani", sub: "Colline, vigneti e borghi" },
            { key: "costa", name: "Costa e Mare", sub: "Litorale e porti" },
        ],
        transfers: {
            title: "Transfer Privati",
            sub: "Da aeroporti, porti e stazioni verso ogni indirizzo di Roma. Servizio porta a porta con autista professionale.",
            chooseCategory: "Scegli la categoria",
            viewPackages: "Vedi i pacchetti",
            stopNoteTitle: "Sosta turistica facoltativa",
            stopNote: "Su molti percorsi è possibile aggiungere una sosta turistica intermedia, sempre su richiesta del cliente e previa verifica di fattibilità e orari. Non è mai obbligatoria.",
            empty: "Nessun transfer pubblicato in questa categoria al momento.",
            allGroups: "Tutti i transfer per categoria",
            fldFrom: "Partenza", fldTo: "Destinazione", fldStops: "Soste", fldDuration: "Durata",
            fldVehicle: "Veicolo", fldPassengers: "Passeggeri", fldLuggage: "Bagagli",
            fldIncludes: "Incluso", fldSupplements: "Supplementi", fldWait: "Attesa", fldConditions: "Condizioni",
            request: "Richiedi questo transfer",
            quoteTitle: "Richiedi il tuo transfer",
            quoteSub: "La richiesta arriva direttamente al nostro team e resta in attesa di conferma finché non la verifichiamo: nessun addebito, nessun impegno.",
            qHub: "Aeroporto / porto", qPickup: "Partenza", qPickupPh: "es. Aeroporto Fiumicino T3, area arrivi",
            qDrop: "Destinazione", qDropPh: "es. Hotel o indirizzo a Roma",
            qDate: "Data", qTime: "Ora", qFlight: "N. volo o nave (facoltativo)", qFlightPh: "es. AZ 611",
            qPax: "Passeggeri", qBags: "Bagagli", qVehicle: "Veicolo",
            qName: "Nome e cognome", qEmail: "Email", qPhone: "Telefono", qNotes: "Note (facoltative)",
            qPrivacy: "Ho letto e accetto l'informativa privacy",
            qSubmit: "Invia la richiesta", qSending: "Invio in corso…",
            qSuccessTitle: "Richiesta ricevuta",
            qSuccessMsg: "Il tuo transfer è in attesa di conferma: ti contatteremo appena l'operatore lo avrà verificato.",
            qCode: "Codice richiesta",
            qRoundTrip: "Andata e ritorno", qReturnDate: "Data ritorno", qReturnTime: "Ora ritorno",
            qReturnFlight: "Volo/nave del ritorno (facoltativo)",
            qRequired: "Compila i campi evidenziati per inviare la richiesta.",
            qAgain: "Invia un'altra richiesta",
            backToList: "Tutti i transfer", detailNotFound: "Transfer non trovato o non più pubblicato.",
            fldAvailability: "Disponibilità", qSelected: "Transfer selezionato",
            qService: "Il servizio selezionato", qReadonly: "Dati del servizio letti dal gestionale: non modificabili dal modulo.",
            qDirArrival: "Arrivo (dall'hub)", qDirDeparture: "Partenza (verso l'hub)",
            qTimeLanding: "Orario previsto di atterraggio", qTimePickup: "Orario di ritiro desiderato",
            qAddressTo: "Indirizzo di destinazione", qAddressToPh: "Hotel o indirizzo a Roma",
            qAddressFrom: "Indirizzo di ritiro", qAddressFromPh: "Hotel o indirizzo di partenza",
            qFirstName: "Nome", qLastName: "Cognome",
            qBagsBig: "Bagagli grandi", qBagsSmall: "Bagagli piccoli",
            qSummaryTitle: "Riepilogo della richiesta",
            qSumWhen: "Data e ora", qSumClient: "Cliente", qSumPax: "Passeggeri", qSumBags: "Bagagli", qSumTotal: "Totale noto",
            qTotalNote: "Il prezzo definitivo, inclusi eventuali supplementi applicabili, è soggetto a conferma dell'operatore.",
            qCapWarn: "I passeggeri indicati superano la capacità di questo veicolo ({n}). Nessuna conferma automatica: invia la richiesta e l'operatore ti proporrà un veicolo adeguato.",
            qSubmitAssist: "Richiedi veicolo adeguato",
            qRoute: "Percorso stimato",
        },
        experiences: {
            title: "Esperienze a Roma",
            sub: "Tour privati, esperienze gastronomiche e itinerari curati, pubblicati e aggiornati dal gestionale Tourvoyagers.",
            all: "Tutte",
            empty: "Nessuna esperienza pubblicata in questa categoria al momento.",
        },
        pkg: {
            back: "Torna al catalogo",
            code: "Codice pacchetto",
            duration: "Durata",
            hours: "ore",
            hour: "ora",
            destination: "Destinazione",
            categoryLabel: "Categoria",
            perPerson: "a persona",
            maxPassengers: "Passeggeri max",
            luggage: "Bagagli",
            vehicle: "Veicolo",
            price: "Prezzo",
            perService: "a servizio",
            included: "Servizi inclusi",
            excluded: "Non inclusi",
            itinerary: "Itinerario",
            stops: "Tappe e soste",
            optionalStop: "Sosta turistica facoltativa disponibile su richiesta, previa verifica di fattibilità.",
            conditions: "Condizioni di vendita",
            cancellation: "Cancellazioni e rimborsi",
            bookRequest: "Richiedi prenotazione",
            bookInstant: "Prenota e paga ora",
            instantNote: "Prenotazione immediata disponibile: disponibilità e prezzo verificati in tempo reale.",
            manualNote: "Questa esperienza richiede una verifica dell'operatore prima della conferma.",
            gallery: "Galleria",
            notFound: "Pacchetto non trovato o non più pubblicato.",
            loading: "Caricamento…",
            svcTitle: "Servizi inclusi nel pacchetto",
            svcTransfers: "Transfer", svcStays: "Alloggi", svcExperiences: "Esperienze",
        },
        booking: {
            title: "Prenota questa esperienza",
            sub: "Compila i dettagli: la richiesta viene registrata nel gestionale Tourvoyagers.",
            date: "Data",
            time: "Orario",
            passengers: "Passeggeri",
            luggage: "Bagagli",
            pickup: "Luogo di partenza",
            dropoff: "Destinazione",
            stopLabel: "Sosta desiderata (facoltativa)",
            notes: "Note",
            name: "Nome e cognome",
            email: "Email",
            phone: "Telefono",
            privacy: "Acconsento al trattamento dei dati personali.",
            submitRequest: "Invia richiesta",
            submitInstant: "Prenota e paga ora",
            sending: "Invio in corso…",
            successTitle: "Richiesta ricevuta",
            successManual: "La tua richiesta è stata registrata nel gestionale Tourvoyagers con stato IN ATTESA DI CONFERMA. Riceverai la conferma solo dopo la verifica dell'operatore.",
            bookingCode: "Codice richiesta",
            errorGeneric: "Si è verificato un errore. Riprova.",
            fallbackToast: "Prenotazione immediata non disponibile per questa data: puoi inviare una richiesta manuale.",
            close: "Chiudi",
        },
        tailor: {
            title: "Esperienza su Misura",
            sub: "Componi il tuo viaggio: lo verifichiamo e ti rispondiamo con una proposta reale.",
            pickup: "Luogo di partenza",
            destination: "Destinazione",
            date: "Data",
            time: "Orario desiderato",
            passengers: "Numero di passeggeri",
            luggageCount: "Numero di bagagli",
            luggageType: "Tipologia bagagli",
            stops: "Soste desiderate",
            duration: "Durata indicativa",
            requests: "Richieste particolari",
            language: "Lingua preferita",
            langIt: "Italiano",
            langEn: "English",
            name: "Nome e cognome",
            email: "Email",
            phone: "Telefono",
            privacy: "Acconsento al trattamento dei dati personali.",
            submit: "Invia richiesta su misura",
            successTitle: "Richiesta inviata",
            successMsg: "La tua richiesta su misura è stata registrata nel gestionale Tourvoyagers. Non equivale a una prenotazione confermata: ti ricontatteremo con una proposta.",
        },
        contact: {
            title: "Contatti & Assistenza",
            sub: "Il nostro team è a disposizione per ogni esigenza di viaggio.",
            name: "Nome e cognome",
            email: "Email",
            subject: "Oggetto",
            message: "Messaggio",
            privacy: "Acconsento al trattamento dei dati personali.",
            send: "Invia messaggio",
            successTitle: "Messaggio inviato",
            successMsg: "Grazie: il tuo messaggio è stato registrato. Ti risponderemo al più presto.",
            officialTitle: "Contatti ufficiali",
        },
        status: {
            pending_confirmation: "In attesa di conferma",
            confirmed: "Confermata",
            cancelled: "Annullata",
            awaiting_payment: "In attesa di pagamento",
            payment_failed: "Pagamento fallito",
            payment_expired: "Pagamento scaduto",
        },
        payment: {
            successTitle: "Pagamento completato",
            successSub: "Stiamo verificando la conferma della tua prenotazione.",
            checking: "Verifica del pagamento in corso…",
            confirmedMsg: "La tua prenotazione è CONFERMATA. Conserva il codice e scarica il voucher.",
            pendingMsg: "Pagamento in verifica: la prenotazione sarà confermata solo a esito positivo.",
            cancelledTitle: "Pagamento annullato",
            cancelledSub: "Nessun addebito è stato effettuato. Puoi riprovare dalla scheda del pacchetto.",
            downloadVoucher: "Scarica il voucher PDF",
            emailForVoucher: "Conferma la tua email per scaricare il voucher",
            bookingCode: "Codice prenotazione",
            statusLabel: "Stato",
            backHome: "Torna alla homepage",
        },
        footer: {
            tagline: "Marketplace turistico premium. Transfer privati, esperienze a Roma e itinerari su misura.",
            navigate: "Navigazione",
            contactsTitle: "Contatti",
            legal: "Informazioni legali",
            privacy: "Privacy Policy",
            cookie: "Cookie Policy",
            terms: "Condizioni di prenotazione",
            cancellationPolicy: "Cancellazioni e rimborsi",
            rights: "Tutti i diritti riservati.",
            adminArea: "Area riservata",
        },
        common: { from: "da", learnMore: "Scopri di più", loading: "Caricamento…", notFoundTitle: "Pagina non trovata", notFoundSub: "Il contenuto richiesto non esiste o è stato spostato.", catalogError: "Catalogo temporaneamente non disponibile. I pacchetti vengono caricati dal gestionale Tourvoyagers: riprova tra poco." },
    },
    en: {
        nav: {
            home: "Home",
            experiences: "Experiences",
            transfers: "Transfers",
            destinations: "Destinations",
            tailor: "Tailor-Made",
            contacts: "Contacts",
            itineraries: "Itineraries",
            createItinerary: "Tailor-made itineraries",
            stays: "Stays",
            about: "About us",
            favorites: "Your favourites",
            favoritesEmpty: "No saved experiences: tap the heart on the cards.",
            account: "Client area",
            bookNow: "Request itinerary",
            admin: "Management Area",
            statusPage: "Request status",
        },
        itinerariesPage: {
            title: "Proposed itineraries & journeys",
            sub: "TOURVOYAGERS' signature experiences and journeys: browse the proposals, discover the details and book. For a journey designed around you, open the trip builder.",
            customTitle: "Create your tailor-made itinerary",
            customSub: "Destinations, dates, experiences, stays and quote: the complete builder",
            empty: "No itineraries available at the moment.",
        },
        concierge: {
            fab: "AI Concierge",
            pageTitle: "Your AI Travel Concierge",
            pageSub: "Tell me about the journey you dream of: I will ask a few questions and compose a tailor-made proposal with real Tourvoyagers services.",
            greeting: "Hello! I am your travel Concierge. Tell me what you would love to experience in Italy and I will help you create a tailor-made itinerary.",
            placeholder: "Write your travel wishes here…",
            send: "Send", thinking: "The Concierge is writing…", reset: "New conversation",
            chips: ["7 days between Rome and the Amalfi Coast", "Romantic weekend in Rome", "Rome, Florence and Venice in 10 days"],
            proposalTitle: "Your journey proposal", stopsTitle: "The stops", nights: "nights",
            servicesTitle: "Services in this proposal", priceQuote: "price on request",
            warningsTitle: "Concierge notes",
            participants: "Participants", pace: "Pace", budget: "Indicative budget",
            mapTitle: "The route",
            requestCta: "Request this proposal",
            disclaimer: "Non-binding proposal: prices and availability are verified by our team before any confirmation.",
            editHint: "Want to change something? Just write it in the chat, e.g. “one more day in Florence” or “add a food experience”.",
            formTitle: "Almost done",
            formSub: "Leave your contacts: our team verifies availability and prices and sends you the quote.",
            cfName: "Full name", cfEmail: "Email", cfPhone: "Phone",
            cfPrivacy: "I have read and accept the privacy policy",
            cfSend: "Send the request", cfSending: "Sending…",
            successTitle: "Proposal sent to our team",
            successMsg: "Your proposal is pending confirmation: we will contact you with the verified quote.",
            codeLabel: "Request code",
            error: "The Concierge is not available right now. Please try again shortly.",
            langNote: "The site language is the conversation language: you can switch anytime without losing anything.",
            listening: "Listening… tap to stop",
            transcribing: "Transcribing your voice…",
            micDenied: "Microphone unavailable: check your browser permissions.",
            voiceOn: "Turn off voice reading",
            voiceOff: "Turn on voice reading of replies",
            journeyTitle: "Your tailor-made journey",
            editItinerary: "Edit itinerary", doneEdit: "Done editing",
            addDestination: "Add destination", chooseCity: "Choose a destination…",
            removeStop: "Remove stop", askAi: "Ask the AI", viewMap: "View on map", hideMap: "Hide map",
            day: "Day",
            programDefault: "The detailed programme for this day is defined with our team during the quote.",
            linkedServices: "Services linked to this stop",
            tabStays: "Stays", tabExperiences: "Experiences", tabTransfers: "Transfers", tabRestaurants: "Restaurants", tabActivities: "Activities",
            selectedForYou: "Selected for you", addedByYou: "Added by you",
            seeDetails: "View details", seeAll: "View all", seeLess: "Show less",
            replace: "Replace", remove: "Remove", close: "Close", backToTrip: "Back to your journey",
            emptyServices: "Your selections will appear here once we have personalised the journey together.",
            emptyItinerary: "Tell me about the journey you dream of: your tailor-made itinerary will appear here, with stops, map and real services.",
            restaurantsNote: "Our restaurant selection is being integrated into the catalogue: to be fair, we do not show unverified venues. Ask the Concierge to include restaurants in your request and our team will propose them in the quote.",
            askRestaurants: "Ask the Concierge for restaurants",
            restaurantsMsg: "I would like to include selected restaurants in my journey: which ones do you recommend for my stops?",
            swapTitle: "Choose an alternative from the real catalogue", swapSearch: "Search by name or place…",
            swapEmpty: "No alternative found in the catalogue.", swapSelect: "Choose", swapLoading: "Loading the catalogue…",
            summaryTitle: "Journey summary", duration: "Duration", days: "days",
            destinations: "Destinations", travelers: "Travellers",
            sumStays: "Selected stays", sumExperiences: "Included experiences", sumTransfers: "Included transfers",
            sumActivities: "Activities & excursions", sumRestaurants: "Restaurants",
            totalLabel: "Indicative total", totalKnownNote: "services with a known price only · non-binding",
            totalUnknown: "Price in the quote",
            quoteCta: "Request a tailor-made quote",
            recapTitle: "Your journey at a glance",
            toastAdded: "Added to your journey", toastRemoved: "Removed from the journey", toastReplaced: "Service replaced",
            toastStopAdded: "Stop added", toastStopRemoved: "Stop removed",
            quickActions: ["Create an itinerary", "Find stays", "Experiences & excursions", "Private transfers", "Selected restaurants"],
            quickMsgs: ["I would like to create a tailor-made itinerary in Italy", "I am looking for a luxury stay for my journey", "I would like authentic experiences and excursions", "I need a private transfer", "I would like advice on selected restaurants for my journey"],
            askAiStop: "I would like to change the stop in {city}.",
            sidebarQuote: "“Luxury is not just the destination, but the way you live the journey.”",
            myTrips: "Your journeys", restaurants: "Restaurants",
            cuisineLabel: "Cuisine", priceRange: "Price range", priceSourceGoogle: "source: Google",
            tableNote: "Booking a table is a request to our team: no table is ever confirmed automatically.",
            restEmpty: "The restaurants we choose together will appear here: ask the Concierge for the best ones along your stops.",
        },
        statusPage: {
            title: "Your request status",
            sub: "Enter the code you received when booking and the email you used.",
            codeLabel: "Booking code",
            codePlaceholder: "e.g. TO-2026-0007",
            emailLabel: "Email used",
            check: "Check status",
            checking: "Checking…",
            notFound: "No request found with these details. Check code and email.",
            registered: "Request registered in the Tourvoyagers management system.",
            liveNote: "Status updated in real time from the management system.",
            lastKnownNote: "Last known status: pending confirmation. Confirmation arrives by email as soon as the operator records it.",
            packageLabel: "Service",
            dateLabel: "Date & time",
        },
        hero: {
            overline: "YOUR JOURNEY, YOUR STORY",
            titleA: "Discover Italy",
            titleB: "beyond the ordinary.",
            subtitle: "Authentic experiences, tailor-made itineraries, transfers and stays for an unforgettable journey.",
            perks: ["Selected experiences", "Personalised service", "24/7 assistance"],
            ctaExperiences: "Explore Experiences",
            ctaTransfers: "Book a Transfer",
            ctaAI: "Create your journey with the AI Concierge",
            ctaExplore: "Explore and book on your own",
            scroll: "Scroll to explore",
        },
        search: {
            tabItinerary: "Create your itinerary",
            tabTransfer: "Airport transfers",
            tabStays: "Stays",
            tabExperiences: "Experiences",
            where: "Where do you want to go?", wherePh: "Rome, Tuscany, Coast…",
            dates: "Travel dates", dateFrom: "From", dateTo: "To",
            people: "Travellers", tripType: "Trip type", tripTypePh: "Culture, Relax, Food & Wine…",
            from: "Pick-up", fromPh: "Airport / Hotel / Address",
            to: "Destination", toPh: "Destination",
            date: "Date", time: "Time", pax: "Passengers", bags: "Luggage",
            hub: "Airport or port", hubFco: "Fiumicino Airport (FCO)", hubCia: "Ciampino Airport (CIA)", hubCiv: "Port of Civitavecchia", hubOther: "Other address",
            vehicle: "Vehicle",
            destination: "Destination", checkin: "Check-in", checkout: "Check-out", guests: "Guests", rooms: "Rooms", stayType: "Type",
            stayTypes: { any: "Any", hotel: "Hotel", boutique: "Boutique Hotel", resort: "Resort", bb: "B&B", villa: "Villa", apartment: "Apartment" },
            category: "Category", anyCategory: "All categories",
            ctaItinerary: "Create itinerary", ctaTransfer: "Request transfer", ctaStays: "Search stays", ctaExperiences: "Discover experiences",
            mini: ["Tailor-made itinerary", "Free quote", "No commitment", "Expert advice"],
            required: "Please complete the highlighted fields to continue.",
            expPh: "Search an experience or a city…",
        },
        trust: ["Professional chauffeurs", "Premium vehicles", "24/7 assistance", "Secure booking"],
        builder: {
            heroTitleA: "Italy.", heroTitleB: "Your Way.",
            heroSub: "Create your own Italian journey, from unforgettable moments in Rome to extraordinary experiences across Italy.",
            ctaCreate: "Create Your Journey", ctaTours: "Explore Signature Tours",
            steps: [
                { t: "Plan your journey", d: "Destinations, dates and style" },
                { t: "Add places and experiences", d: "Choose from our curated selection" },
                { t: "See your itinerary", d: "Map, timeline and visual preview" },
                { t: "Book or request", d: "Instant booking or tailored quote" },
            ],
            chooseTitle: "Where would you like to go?",
            chooseSub: "A private tour within Rome, or a journey across Italy: choose your mode.",
            romeCard: "Explore Rome",
            romeSub: "Create your perfect private tour through Rome's iconic landmarks, historic streets and hidden gems.",
            italyCard: "Discover Italy",
            italySub: "Design a tailor-made journey across Italy, combining cities, landscapes, culture and unforgettable experiences.",
            examples: ["Rome → Florence → Venice", "Rome → Naples → Amalfi Coast", "Milan → Lake Como → Verona → Venice"],
            examplesNote: "Illustrative itineraries: bookable destinations come from the real catalogue.",
            start: "Start", changeMode: "Change mode",
            signatureTitle: "Signature Tours",
            signatureSub: "Tours from the official Tourvoyagers catalogue: bookable as they are or customisable.",
            explore: "Explore Tour", customize: "Customize This Tour",
            prefDate: "Preferred date", prefPax: "Participants", prefTime: "Available time", prefInterests: "Interests", prefPace: "Preferred pace",
            paces: { relaxed: "Relaxed", balanced: "Balanced", intense: "Intense" },
            times: { "2h": "Up to 2 hours", "4h": "Half day (4h)", "8h": "Full day (8h)", multi: "Multiple days" },
            interests: { history: "History & Culture", art: "Art & Architecture", food: "Food & Gastronomy", hidden: "Hidden Gems", views: "Panoramic Views", shopping: "Shopping", religious: "Religious Heritage", family: "Family Experiences", nature: "Nature & Parks", sea: "Sea & Coastal Villages", craft: "Crafts & Local Traditions", exclusive: "Exclusive Experiences", wellness: "Wellness & Thermal Baths", archeology: "Archaeology & Ancient Sites" },
            catalogTitle: "Places catalogue", destCatalogTitle: "Italian destinations",
            searchPh: "Search places, monuments, districts…", destSearchPh: "Search destinations, cities, regions…",
            add: "Add", added: "Added", remove: "Remove",
            yourTour: "Your Rome tour", yourJourney: "Your Italian Journey",
            stopsEmpty: "No stops yet: add places from the catalogue.",
            destEmpty: "No destinations yet: add them from the catalogue.",
            nights: "nights", night: "night", addDest: "Add another destination",
            startDate: "Departure date", transport: "Preferred transport",
            transports: { car: "Vehicle", minivan: "Minivan", sprinter: "Mercedes-Benz Sprinter" },
            transportCap: "up to {n} guests",
            capWarn: "Your party of {pax} exceeds the capacity of {name} (max {cap} guests).",
            capWarnHint: "Choose a larger vehicle or request a tailor-made solution: we will arrange it with you.",
            capCustomBtn: "Request a tailor-made solution",
            capCustomSet: "Tailor-made solution requested: we will arrange it with you",
            budget: "Indicative budget (optional)", budgetPh: "e.g. 4,000",
            budgetHint: "For the whole journey · non-binding",
            wizard: {
                steps: [
                    { t: "Destinations", d: "Cities, dates and stops" },
                    { t: "Stays", d: "Where you will sleep" },
                    { t: "Transport", d: "Vehicle and guests" },
                    { t: "Experiences", d: "What you will live" },
                    { t: "Summary", d: "Budget and quote" },
                ],
                back: "Back", next: "Continue",
                staysTitle: "Your stays", staysSub: "Choose where to sleep at each stop: availability and price are verified in the quote.",
                staysEmpty: "Add at least one destination to your journey first.", staysGo: "Go to destinations",
                stayPick: "Choose stay", stayChange: "Change",
                transportTitle: "Your transport", transportSub: "Tell us your party size and preferred vehicle: availability is verified with the quote.",
                fleetTitle: "The fleet at your disposal",
                expStepTitle: "Your experiences", expStepSub: "Pick a category and add real experiences to your itinerary.",
                expAddedTitle: "Experiences in your itinerary",
                summaryTitle: "Final step", summarySub: "Add an indicative budget (optional), preview your journey and request the quote.",
                quoteCta: "Request the quote",
            },
            catSub: {
                history: "Monuments, museums, historic towns and treasures of the past.",
                art: "Museums, palaces, historic villas and Italian art masterpieces.",
                food: "Wineries, tastings, olive mills, DOP products and regional cuisine.",
                hidden: "Villages, characterful quarters and places off the beaten path.",
                views: "Terraces, belvederes and scenic roads across cities, hills and coasts.",
                shopping: "Boutiques, outlets, artisan workshops and historic markets.",
                religious: "Basilicas, sanctuaries, abbeys and spiritual itineraries.",
                family: "Parks, museums and activities designed for travelling with children.",
                nature: "National parks, historic gardens and nature reserves.",
                sea: "Seaside villages, beaches and boat excursions.",
                craft: "Ceramics, glass, leather and ancient Italian crafts.",
                exclusive: "Private visits and reserved experiences, tailor-made.",
                wellness: "Thermal baths, natural springs and wellness experiences.",
                archeology: "Excavations, temples and archaeological sites unique in the world.",
            },
            expFilters: "Filters", expRegion: "Region", expAllRegions: "All regions",
            expDur: "Duration", expDurAll: "Any duration", expDurShort: "Up to 3 hours", expDurHalf: "Half day", expDurFull: "Full day",
            expAdd: "Add to itinerary", expAdded: "In your itinerary", expRemove: "Remove",
            expDurIndicative: "indicative duration",
            expPriceNote: "Price and availability will be verified and communicated in the final quote.",
            expEmpty: "No experiences available with these filters.",
            expRomeNote: "Discover Rome mode: experiences in Rome and its surroundings.",
            expBadge: "Experience", expClose: "Close the catalogue", expLoading: "Loading experiences…",
            sumExperiences: "Selected experiences", sumBudget: "Indicative budget",
            days: "Days", sumStops: "Stops", sumDuration: "Estimated duration", sumCities: "Destinations", sumNights: "Nights", sumExp: "Experiences",
            sumDistance: "Total distance", sumDrive: "Drive time", customPlace: "from Google Maps",
            estTitle: "Indicative estimate", estNote: "Non-binding range based on stops, real kilometres and participants: your personal quote follows your request.",
            modeRome: "Discover Rome", modeRomeSub: "An experience devoted to the Eternal City",
            modeItaly: "Tour of Italy", modeItalySub: "Multiple destinations, experiences and stays",
            heroLabel: "YOUR JOURNEY", heroItalyTitle: "Discover Italy", heroRomeTitle: "Discover Rome",
            heroItalySub: "Design a tailor-made journey across Italy, combining cities, landscapes, culture and unforgettable experiences.",
            heroRomeSub: "Design your experience in the Eternal City: monuments, neighbourhoods, art and unforgettable moments.",
            addDestination: "Add destination", addPlace: "Add place", exploreMore: "Explore more destinations",
            continueSummary: "Continue to summary", yourJourneyTitle: "Your Italian Journey", yourJourneySub: "Your selected destinations and stops",
            yourRomeTitle: "Your Roman stay", yourRomeSub: "Your visits organised day by day",
            accommodationBtn: "Accommodation", attractionsBtn: "Attractions", nightsShort: "Nights",
            featExplore: "Explore the cities", featExploreSub: "Monuments, history and culture",
            featStays: "Choose your stays", featStaysSub: "Hotels, boutique & apartments",
            featTailor: "Tailor-made itinerary", featTailorSub: "Everything in one journey",
            featExclusive: "Exclusive experiences", featExclusiveSub: "Live Italy with us",
            addDestinations: "Add destinations", searchCityPh: "Search a city…", popularDest: "Popular destinations",
            exploreCity: "Explore the city", findStay: "Find your stay",
            attractionsSelected: "{n} attractions selected", noAttractions: "No attractions yet",
            staySelected: "Stay selected", stayMissing: "No stay selected yet", stayReconfirm: "To reconfirm: dates changed",
            staySetDates: "Set the departure date to compute the stop dates",
            sumStays: "Stays selected", sumStayCost: "Stays cost (as entered by you)", sumTotal: "Indicative total",
            sumTitle: "Journey summary", sumAttractions: "Attractions selected",
            requestQuote: "Request quote", programTitle: "Visits schedule",
            dayAssign: "Day", dayUnassigned: "To be planned", dayN: "Day {n}",
            romeStayDays: "Days in Rome", arrival: "Arrival", departure: "Departure",
            xp: {
                back: "Back to your journey", story: "History & origins", periods: "The great periods",
                heritage: "Artistic & cultural heritage", distinctive: "What makes it unique",
                tips: "Tips for planning your visit", gallery: "Attractions",
                mustSee: "Not to be missed", allCats: "All", searchPh: "Search a place, a monument…",
                discoverStory: "Discover its story", add: "Add to my itinerary", added: "In your itinerary",
                curiosity: "Curiosity", practical: "Practical tips", duration: "Suggested visit",
                needCity: "Add {city} to your journey first to select its attractions",
                loading: "Preparing the {city} guide…", loadingSub: "Texts, photographs and real positions on their way",
                noResults: "No attraction matches your search.",
                retry: "Retry", errorMsg: "The guide did not load completely. Check your connection and try again: the content is ready to arrive.",
            },
            stay: {
                title: "Your stay in {city}", dates: "Check-in → Check-out", guests: "Guests", rooms: "Rooms",
                type: "Preferred type", anyType: "Any",
                types: { luxury: "Luxury hotel", boutique: "Boutique hotel", mid: "Mid-range", bb: "Bed & Breakfast", apartment: "Apartment", residence: "Residence" },
                searchPartner: "Search on Booking.com with these dates",
                partnerNote: "Real prices, photos and availability live on the partner site: the booking is completed there, then register your choice here to include it in the quote.",
                register: "Register your chosen property", namePh: "Property name (e.g. Hotel Artemide)",
                pricePh: "Total stay price € (optional)", linkPh: "Property link (optional)",
                save: "Save stay", replace: "Replace", remove: "Remove",
                statusSelected: "Selected — booking to be completed on the partner site",
                listSub: "Select the stay for this stop: verified proposals or a tailor-made solution.",
                editDates: "Edit dates & guests", catLabel: "Category", catAll: "All categories",
                catLuxury: "Luxury", catMid: "Mid-range", catValue: "Essential", searchNamePh: "Search a property…",
                viewMap: "View on the map", select: "Select this stay", selected: "Selected", removeSel: "Remove selection",
                priceNote: "The accommodation price will be communicated in the final quote, subject to availability.",
                priceSummary: "Price to be defined in the final quote",
                ratingSuffix: "on Google · {n} reviews",
                noFit: "Can't find the right solution?", customCta: "Request a personalised proposal",
                customPh: "Describe your needs: style, area, desired amenities…",
                customName: "Personalised proposal", skip: "Skip and continue",
                emptyCatalog: "The verified catalogue for this destination is being prepared: meanwhile you can request a personalised proposal.",
                partnerFallback: "Search on the partner site anyway",
                viewPhotos: "Browse the gallery", backToResults: "Back to results", photoCount: "{n} photos",
                photosCredit: "Real photos of the property · Source: Google Maps",
                noMorePhotos: "No further verified images are available for this property.",
                roomsTitle: "Room types",
                roomsNote: "Room-specific photos and details (beds, size, included amenities, breakfast and cancellation) are not available from the verified source: they will be proposed in the final quote, subject to availability.",
            },
            partialNote: "Partial estimate: indicative visit durations plus real drive times computed with Google Maps; extra services excluded.",
            day: "Day", daysRange: "Days",
            suggNearby: "You may also enjoy adding {name}.",
            suggRelaxed: "At a relaxed pace, {n} stops may be too many for the available time.",
            suggDest: "{name} could be a wonderful addition to your Italian journey.",
            mapIndicative: "Map, real positions and road connections computed with Google Maps.",
            mapLegendStops: "Stops", mapLegendAttractions: "Attractions", mapLegendStays: "Stays",
            placesPh: "Search any place or city with Google…",
            mapFallbackTitle: "Interactive map",
            mapFallbackText: "The Google Maps view activates as soon as the API key is configured. Meanwhile, manage your stops order from the list: positions and coordinates are already the real ones.",
            preview: "Preview My Journey",
            pvVisual: "Visual Journey", pvMap: "Interactive Map", pvDays: "Day-by-Day Itinerary", pvDetails: "Details",
            request: "Request My Bespoke Journey",
            bkTitle: "Request your bespoke journey",
            bkSub: "The full structure of your itinerary is sent to the Tourvoyagers management system.",
            bkSubmit: "Send request",
            bkSuccessTitle: "Request received",
            bkSuccessMsg: "Your itinerary has been registered in the Tourvoyagers management system with the complete journey structure. It is not a confirmed booking: we will contact you with a proposal.",
        },
        marquee: ["ROME", "PRIVATE TRANSFERS", "TAILOR-MADE JOURNEYS", "EXCLUSIVE EXPERIENCES", "CIVITAVECCHIA CRUISE TRANSFERS", "TRAVEL DIFFERENTLY"],
        home: {
            featuredOverline: "Our collections",
            featuredTitle: "Explore the experiences",
            featuredSub: "Every itinerary is designed to let you live Rome and its surroundings in an authentic, unforgettable way.",
            viewAll: "View all experiences",
            dest2: {
                title: "Featured destinations",
                cards: [
                    { key: "roma", name: "Rome" },
                    { key: "costiera", name: "Amalfi Coast" },
                    { key: "toscana", name: "Tuscany" },
                    { key: "food", name: "Food & Wine Experiences" },
                    { key: "arte", name: "Art & Culture" },
                    { key: "tour", name: "Private Tours" },
                ],
            },
            featExp: {
                title: "Featured experiences", viewAll: "View all experiences",
                quoteTag: "Price in the final quote", perPersonNote: "Availability and price verified in the quote",
            },
            transferBanner: {
                label: "AIRPORT TRANSFERS", title: "Arrive in Italy without a worry",
                sub: "Private transfers to and from Fiumicino, Ciampino and all other Italian airports.",
                cta: "Book your transfer",
                meetGreet: "Meet & Greet at the airport",
                freeWait: "Free waiting time up to {n} minutes",
                flightTrack: "Flight monitoring",
                luggage: "Luggage assistance",
                proDrivers: "Professional multilingual drivers",
            },
            hubsOverline: "ARRIVALS & DEPARTURES",
            hubsTitle: "Wherever you land, we welcome you",
            hubCta: "Request a transfer",
            hubs: [
                { slug: "transfer-fco", name: "Fiumicino Airport", sub: "FCO · Leonardo da Vinci, arrivals terminals" },
                { slug: "transfer-cia", name: "Ciampino Airport", sub: "CIA · G. B. Pastine" },
                { slug: "transfer-civitavecchia", name: "Port of Civitavecchia", sub: "Cruise terminal" },
            ],
            staysBanner: {
                label: "SELECTED STAYS", title: "Stay in unique places",
                sub: "Hotels, Boutique Hotels, Villas and Apartments from our selected partners.",
                cta: "Discover the stays",
                chips: ["Verified properties", "Dedicated assistance", "Price in the final quote"],
            },
            cities: {
                title: "Our destinations", viewAll: "View all destinations",
                cards: [
                    { key: "roma", name: "Rome", sub: "Eternal history" },
                    { key: "costiera", name: "Amalfi Coast", sub: "Sea and beauty" },
                    { key: "toscana", name: "Tuscany", sub: "Villages and nature" },
                    { key: "venezia", name: "Venice", sub: "Art and romance" },
                    { key: "firenze", name: "Florence", sub: "Cradle of the Renaissance" },
                    { key: "sicilia", name: "Sicily", sub: "Traditions and flavours" },
                ],
            },
            about: {
                title: "About us",
                text: "Italy is not just a destination: it is an emotion to live. We accompany travellers in discovering the timeless beauty of Rome and Italy, turning every stay into an experience built around the wishes, interests and style of those who travel.",
                cta: "Contact us",
                readMore: "Discover who we are",
            },
            aboutPage: {
                overline: "Rome & Italy Experiences",
                title: "About us",
                intro1: "Italy is not just a destination. It is an emotion to live, a heritage to discover, an experience to remember.",
                intro2: "Tourvoyagers was born to accompany travellers in discovering the timeless beauty of Rome and Italy, turning every stay into a special experience, built around the wishes, interests and style of those who travel.",
                intro3: "We believe true luxury is not just reaching a destination, but living it in the right way: with comfort, attention to detail, freedom of choice and the chance to discover the places, stories and atmospheres that make every journey unique.",
                s1t: "Our idea of travel",
                s1a: "From the timeless wonders of the Eternal City to the hidden treasures of Italian destinations, we design experiences for those who wish to know the land from a privileged point of view.",
                s1b: "With Tourvoyagers you can discover exclusive experiences, tailor-made itineraries, selected stays, private transfers and dedicated solutions to make every journey simple and comfortable.",
                s1c: "Every proposal stems from one fundamental principle: the journey must adapt to you, not the other way around.",
                s2t: "Experiences created around you",
                s2a: "Every traveller has a story, a rhythm and a personal way of discovering the world. That is why we value personalisation, attention to individual needs and care for every detail, from planning the journey to transfers and experiences on site.",
                s2b: "Whether you wish to explore Rome's most iconic monuments, be surprised by authentic itineraries, organise a special stay or reach your destination with a private transfer, our goal is to offer you a simple, pleasant journey that lives up to your expectations.",
                s3t: "The elegance of Italian hospitality",
                s3a: "We are inspired by the all-Italian ability to combine beauty, culture, style and warmth. Every detail matters: the time devoted to planning, the quality of the proposals, the comfort of the transfers and the peace of mind of relying on attentive organisation.",
                s3b: "We want you to focus on the most beautiful part of the journey: discovering, being moved and creating memories.",
                s4t: "Your next experience starts here",
                s4a: "Rome is our starting point, Italy our horizon and the world of travel our passion.",
                tagline: "Tourvoyagers. Discover Italy. Experience more.",
                s4b: "Let yourself be inspired, tell us what you imagine and start designing your next journey with us.",
                ctaContact: "Tell us about your journey",
                ctaConcierge: "Talk to the AI Concierge",
            },
            trustBottom: ["Authentic experiences selected with care", "24/7 assistance during your journey", "Free quote with no commitment", "Tailor-made journeys for every need"],
            discover: "Discover the experience",
            editorialOverline: "Private experiences",
            editorialTitle: "You choose the destination, we take care of the rest.",
            editorialFeatures: ["Tailor-made itineraries", "Guides on request", "Premium vehicles", "Culinary experiences"],
            editorialCta: "Create your itinerary",
            airportsOverline: "Arrivals & Departures",
            airportsTitle: "Airport Transfers",
            airportsSub: "Meet & greet at Fiumicino and Ciampino with dedicated chauffeur, flight tracking and waiting time included.",
            allTransfers: "All transfers",
            fcoTitle: "Fiumicino Airport (FCO)",
            fcoSub: "Rome's international gateway, moments from the centre.",
            ciaTitle: "Ciampino Airport (CIA)",
            ciaSub: "A fast, private connection into the city.",
            cruiseOverline: "Cruises",
            cruiseTitle: "Port of Civitavecchia",
            cruiseSub: "Transfers coordinated with your ship's schedule, with an optional sightseeing stop on request.",
            cruiseCta: "Cruise transfers",
            destOverline: "More than a journey",
            destTitle: "Destinations & tailor-made experiences",
            destSub: "From the Eternal City to the wonders of the region. Personalised itineraries for every need.",
            destCta: "Request an itinerary",
            travelTitle: "Travel Differently",
            travelSub: "More than a transfer, a travel experience.",
            travelCta: "Contact us",
            contactOverline: "Contacts & Assistance",
            contactTitle: "Got a travel idea? Let's talk.",
            contactSub: "Our team is available to create a tailor-made experience with you.",
            contactCta: "Contact us",
        },
        staysPage: {
            overline: "SELECTED STAYS", title: "Stay in unique places",
            sub: "Verified Hotels, Boutique Hotels, Villas and Apartments from our partners, city by city. The price is always communicated in the final quote, after availability check.",
            choose: "Choose a destination to discover the selected properties.",
            resultsIn: "selected properties in", reviews: "reviews", rooms: "Rooms",
            cta: "Request with itinerary", empty: "No properties available for this destination at the moment.",
        },
        destinations: [
            { key: "roma", name: "Rome", sub: "The Eternal City" },
            { key: "tivoli", name: "Tivoli", sub: "Imperial villas & gardens" },
            { key: "castelli", name: "Castelli Romani", sub: "Hills, vineyards & villages" },
            { key: "costa", name: "Coast & Sea", sub: "Seaside & harbours" },
        ],
        transfers: {
            title: "Private Transfers",
            sub: "From airports, ports and stations to any address in Rome. Door-to-door service with a professional chauffeur.",
            chooseCategory: "Choose a category",
            viewPackages: "View packages",
            stopNoteTitle: "Optional sightseeing stop",
            stopNote: "On many routes you can add an intermediate sightseeing stop — always on customer request and subject to feasibility and schedule checks. It is never mandatory.",
            empty: "No transfers published in this category yet.",
            allGroups: "All transfers by category",
            fldFrom: "Departure", fldTo: "Destination", fldStops: "Stops", fldDuration: "Duration",
            fldVehicle: "Vehicle", fldPassengers: "Passengers", fldLuggage: "Luggage",
            fldIncludes: "Included", fldSupplements: "Supplements", fldWait: "Waiting time", fldConditions: "Terms",
            request: "Request this transfer",
            quoteTitle: "Request your transfer",
            quoteSub: "Your request goes straight to our team and stays pending confirmation until we verify it: no charge, no commitment.",
            qHub: "Airport / port", qPickup: "Pick-up", qPickupPh: "e.g. Fiumicino Airport T3, arrivals hall",
            qDrop: "Drop-off", qDropPh: "e.g. hotel or address in Rome",
            qDate: "Date", qTime: "Time", qFlight: "Flight or ship no. (optional)", qFlightPh: "e.g. AZ 611",
            qPax: "Passengers", qBags: "Luggage", qVehicle: "Vehicle",
            qName: "Full name", qEmail: "Email", qPhone: "Phone", qNotes: "Notes (optional)",
            qPrivacy: "I have read and accept the privacy policy",
            qSubmit: "Send request", qSending: "Sending…",
            qSuccessTitle: "Request received",
            qSuccessMsg: "Your transfer is pending confirmation: we will contact you as soon as the operator verifies it.",
            qCode: "Request code",
            qRoundTrip: "Round trip", qReturnDate: "Return date", qReturnTime: "Return time",
            qReturnFlight: "Return flight/ship no. (optional)",
            qRequired: "Please fill in the highlighted fields to send the request.",
            qAgain: "Send another request",
            backToList: "All transfers", detailNotFound: "Transfer not found or no longer published.",
            fldAvailability: "Availability", qSelected: "Selected transfer",
            qService: "The selected service", qReadonly: "Service data read from the management system: not editable from this form.",
            qDirArrival: "Arrival (from the hub)", qDirDeparture: "Departure (to the hub)",
            qTimeLanding: "Estimated landing time", qTimePickup: "Desired pick-up time",
            qAddressTo: "Destination address", qAddressToPh: "Hotel or address in Rome",
            qAddressFrom: "Pick-up address", qAddressFromPh: "Hotel or pick-up address",
            qFirstName: "First name", qLastName: "Last name",
            qBagsBig: "Large bags", qBagsSmall: "Small bags",
            qSummaryTitle: "Request summary",
            qSumWhen: "Date and time", qSumClient: "Client", qSumPax: "Passengers", qSumBags: "Luggage", qSumTotal: "Known total",
            qTotalNote: "The final price, including any applicable supplements, is subject to operator confirmation.",
            qCapWarn: "The passengers entered exceed this vehicle's capacity ({n}). No automatic confirmation: send the request and the operator will propose a suitable vehicle.",
            qSubmitAssist: "Request a suitable vehicle",
            qRoute: "Estimated route",
        },
        experiences: {
            title: "Rome Experiences",
            sub: "Private tours, culinary experiences and curated journeys, published and updated from the Tourvoyagers management system.",
            all: "All",
            empty: "No experiences published in this category yet.",
        },
        pkg: {
            back: "Back to catalogue",
            code: "Package code",
            duration: "Duration",
            hours: "hours",
            hour: "hour",
            destination: "Destination",
            categoryLabel: "Category",
            perPerson: "per person",
            maxPassengers: "Max passengers",
            luggage: "Luggage",
            vehicle: "Vehicle",
            price: "Price",
            perService: "per service",
            included: "Included services",
            excluded: "Not included",
            itinerary: "Itinerary",
            stops: "Stops",
            optionalStop: "Optional sightseeing stop available on request, subject to feasibility checks.",
            conditions: "Sales conditions",
            cancellation: "Cancellations & refunds",
            bookRequest: "Request booking",
            bookInstant: "Book & pay now",
            instantNote: "Instant booking available: availability and price verified in real time.",
            manualNote: "This experience requires operator verification before confirmation.",
            gallery: "Gallery",
            notFound: "Package not found or no longer published.",
            loading: "Loading…",
            svcTitle: "Services included in the package",
            svcTransfers: "Transfers", svcStays: "Stays", svcExperiences: "Experiences",
        },
        booking: {
            title: "Book this experience",
            sub: "Fill in the details: your request is registered in the Tourvoyagers management system.",
            date: "Date",
            time: "Time",
            passengers: "Passengers",
            luggage: "Luggage",
            pickup: "Pickup location",
            dropoff: "Destination",
            stopLabel: "Desired stop (optional)",
            notes: "Notes",
            name: "Full name",
            email: "Email",
            phone: "Phone",
            privacy: "I consent to the processing of my personal data.",
            submitRequest: "Send request",
            submitInstant: "Book & pay now",
            sending: "Sending…",
            successTitle: "Request received",
            successManual: "Your request has been registered in the Tourvoyagers management system with status PENDING CONFIRMATION. You will receive confirmation only after operator verification.",
            bookingCode: "Request code",
            errorGeneric: "Something went wrong. Please try again.",
            fallbackToast: "Instant booking is not available for this date: you can send a manual request instead.",
            close: "Close",
        },
        tailor: {
            title: "Tailor-Made Experience",
            sub: "Compose your journey: we verify it and reply with a real proposal.",
            pickup: "Pickup location",
            destination: "Destination",
            date: "Date",
            time: "Preferred time",
            passengers: "Number of passengers",
            luggageCount: "Number of bags",
            luggageType: "Luggage type",
            stops: "Desired stops",
            duration: "Approximate duration",
            requests: "Special requests",
            language: "Preferred language",
            langIt: "Italiano",
            langEn: "English",
            name: "Full name",
            email: "Email",
            phone: "Phone",
            privacy: "I consent to the processing of my personal data.",
            submit: "Send tailor-made request",
            successTitle: "Request sent",
            successMsg: "Your tailor-made request has been registered in the Tourvoyagers management system. It is not a confirmed booking: we will get back to you with a proposal.",
        },
        contact: {
            title: "Contacts & Assistance",
            sub: "Our team is available for every travel need.",
            name: "Full name",
            email: "Email",
            subject: "Subject",
            message: "Message",
            privacy: "I consent to the processing of my personal data.",
            send: "Send message",
            successTitle: "Message sent",
            successMsg: "Thank you: your message has been registered. We will reply as soon as possible.",
            officialTitle: "Official contacts",
        },
        status: {
            pending_confirmation: "Pending confirmation",
            confirmed: "Confirmed",
            cancelled: "Cancelled",
            awaiting_payment: "Awaiting payment",
            payment_failed: "Payment failed",
            payment_expired: "Payment expired",
        },
        payment: {
            successTitle: "Payment completed",
            successSub: "We are verifying your booking confirmation.",
            checking: "Verifying payment…",
            confirmedMsg: "Your booking is CONFIRMED. Keep the code and download your voucher.",
            pendingMsg: "Payment under verification: the booking will be confirmed only upon success.",
            cancelledTitle: "Payment cancelled",
            cancelledSub: "No charge was made. You can try again from the package page.",
            downloadVoucher: "Download PDF voucher",
            emailForVoucher: "Confirm your email to download the voucher",
            bookingCode: "Booking code",
            statusLabel: "Status",
            backHome: "Back to homepage",
        },
        footer: {
            tagline: "Premium travel marketplace. Private transfers, Rome experiences and tailor-made journeys.",
            navigate: "Navigation",
            contactsTitle: "Contacts",
            legal: "Legal information",
            privacy: "Privacy Policy",
            cookie: "Cookie Policy",
            terms: "Booking terms",
            cancellationPolicy: "Cancellations & refunds",
            rights: "All rights reserved.",
            adminArea: "Reserved area",
        },
        common: { from: "from", learnMore: "Learn more", loading: "Loading…", notFoundTitle: "Page not found", notFoundSub: "The requested content does not exist or has been moved.", catalogError: "Catalogue temporarily unavailable. Packages are loaded from the Tourvoyagers management system: please try again shortly." },
    },
};

const LangContext = createContext(null);

/** Le 16 lingue della piattaforma: nomi in forma nativa per il selettore. */
export const LOCALES = [
    { code: "it", label: "Italiano" },
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "es", label: "Español" },
    { code: "de", label: "Deutsch" },
    { code: "pt", label: "Português" },
    { code: "zh-hans", label: "中文（简体）" },
    { code: "zh-hant", label: "中文（繁體）" },
    { code: "ar", label: "العربية" },
    { code: "ru", label: "Русский" },
    { code: "ja", label: "日本語" },
    { code: "ko", label: "한국어" },
    { code: "hi", label: "हिन्दी" },
    { code: "tr", label: "Türkçe" },
    { code: "nl", label: "Nederlands" },
    { code: "pl", label: "Polski" },
];

/* Traduzioni generate da i18n_tools/translate_i18n.py (AI) a partire dall'albero
 * inglese: caricate SOLO quando la lingua viene scelta (bundle leggero). */
const LOCALE_LOADERS = {
    fr: () => import("@/locales/fr.json"),
    es: () => import("@/locales/es.json"),
    de: () => import("@/locales/de.json"),
    pt: () => import("@/locales/pt.json"),
    "zh-hans": () => import("@/locales/zh-hans.json"),
    "zh-hant": () => import("@/locales/zh-hant.json"),
    ar: () => import("@/locales/ar.json"),
    ru: () => import("@/locales/ru.json"),
    ja: () => import("@/locales/ja.json"),
    ko: () => import("@/locales/ko.json"),
    hi: () => import("@/locales/hi.json"),
    tr: () => import("@/locales/tr.json"),
    nl: () => import("@/locales/nl.json"),
    pl: () => import("@/locales/pl.json"),
};

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
const deepMerge = (base, over) => {
    if (!isObj(over)) return over !== undefined ? over : base;
    const out = { ...(isObj(base) ? base : {}) };
    for (const [k, v] of Object.entries(over)) out[k] = k in out ? deepMerge(out[k], v) : v;
    return out;
};

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("tv_lang") || "it");
    const [extra, setExtra] = useState(null);
    useEffect(() => {
        localStorage.setItem("tv_lang", lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        if (lang === "it" || lang === "en" || !LOCALE_LOADERS[lang]) { setExtra(null); return undefined; }
        let alive = true;
        LOCALE_LOADERS[lang]().then((m) => alive && setExtra(m.default || m)).catch(() => alive && setExtra(null));
        return () => { alive = false; };
    }, [lang]);
    /* Catena di fallback coerente: italiano (originale completo) → inglese → lingua scelta. */
    const t = useMemo(() => {
        if (lang === "it") return translations.it;
        const enFull = deepMerge(translations.it, translations.en);
        if (lang === "en" || !extra) return enFull;
        return deepMerge(enFull, extra);
    }, [lang, extra]);
    return <LangContext.Provider value={{ lang, setLang, t, locales: LOCALES }}>{children}</LangContext.Provider>;
}

export function useLang() {
    return useContext(LangContext);
}

export function pick(field, lang) {
    if (field == null) return "";
    if (typeof field !== "object") return field; // stringhe e numeri passano invariati
    return field[lang] || field.en || field.it || "";
}
